import '../../common/bn-action';
import '../../common/bn-bread-crumbs';
import '../../common/bn-card';
import '../../common/bn-flash';
import '../../common/bn-icon';
import '../../common/bn-load-more-button';
import '../../common/bn-loading';
import '../../common/bn-surface';
import '../../organizations/parts/organization-ancestors-bread-crumbs';
import '../../organizations/parts/organization-dropdown';
import { sharedStyles } from '../../styles/shared-styles';
import { css, html, LitEntity, SirenActionMixin, renderIf } from '../../utility/lit-entity';

class LocationAssign extends SirenActionMixin(LitEntity) {
  constructor() {
    super();
    this.users = [];
  }

  static get properties() {
    return {
      scheduledFor: { type: String },
      selectedUser: { type: Object, attribute: false },
      users: { type: Array, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      .actions {
        padding: 1em;
      }
      .target-user {
        font-weight: bold;
      }
      bn-surface[selected] {
        background-color: var(--blue-20);
        border: 1px solid var(--blue-60);
      }
      bn-form-field {
        max-width: 12rem;
        display: block;
      }
    `];
  }

  render() {
    if (!this.entity) {
      return html`<bn-loading></bn-loading>`;
    }

    return html`
      <p class="subdued">
        Assign a user and date to this work order location.
      </p>
      <h4>Users</h4>
      ${this._renderUsers()}
      <div>
        <bn-form-field
          title="Scheduled For"
          name="scheduled-for"
          type="date"
          @input="${(e) => this.scheduledFor = e.target.input.value}"
          .value="${this.scheduledFor}"
          required
        ></bn-form-field>
      </div>
      <bn-flash></bn-flash>
      ${this._renderActions()}
    `;
  }

  _renderUsers() {
    if (this.selectedUser) {
      return html`
        <bn-surface selected>
          ${this.selectedUser.properties.name}
        </bn-surface>
      `;
    }
    if (!this.users.length) {
      return html`<p class="no-data">No users to display.</p>`;
    }
    return html`
      <div class="user-list">
        ${this.users.map((user) => html`
          <bn-card @click=${() => this._selectUser(user)}>${user.properties.name}</bn-card>
        `)}
      </div>
      <bn-load-more-button .href="${this.href}" @moreloaded="${this._onMoreLoaded}"></bn-load-more-button>
    `;
  }

  _renderActions() {
    const ready = this.selectedUser && this.scheduledFor;
    return html`
      <div class="actions well">
        <button class="button button--contained" @click="${this._submitAction}" ?disabled="${!ready}">
          Assign Work Order Location
        </button>
        ${renderIf(this.selectedUser, () => html`to <span class="target-user">${this.selectedUser.properties.name}</span>`)}
      </div>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.selectedUser = this.entity.getSubEntityByClass('selected');
    this.users = this.entity.getSubEntitiesByClass('selectable-item');
  }

  _onMoreLoaded(e) {
    const { entity } = e.detail;
    this.users = [...this.users, ...entity.getSubEntitiesByRel('selectable-item')];
  }

  _selectUser(user) {
    this.href = user.getActionByName('select').href;
  }

  async _submitAction() {
    const action = this.entity.getAction('assign-installer');
    const flash = this.shadowRoot.querySelector('bn-flash');
    flash.clear();
    try {
      if (!action) {
        throw new Error(`Could not find [${this.actionname}] action`);
      }
      const fields = this.getActionFields(action);
      fields.set('scheduledFor', this.scheduledFor);
      this.dispatchEvent(new CustomEvent('submit', { bubbles: true, composed: true }));
      const { entity, response, error } = await this.submitAction(action, fields);
      if (error) {
        throw new Error(error);
      }
      flash && flash.success(this.successtext || 'Success.');
      this.dispatchEvent(new CustomEvent('response', { detail: { entity, response }, bubbles: true, composed: true }));
    } catch (error) {
      flash && flash.critical(html`${this.errortext}<div><code>${error.message}</code></div>`);
      this.dispatchEvent(new ErrorEvent('error', { error, bubbles: true, composed: true }));
    }
  }
}

window.customElements.define('location-assign', LocationAssign);
